import React, { useState, useEffect } from "react";
import "./BusinessSolutions.css";
import fullpuzzle from "../../assets/fullpuzzle.webp";

const puzzleItems = [
  {
    src: require("../../assets/puzzle1.webp"),
    title: "Finance",
    text: "",
    hoverText: "Tailored financial planning.",
    position: { top: "0", left: "-50px" },
    size: { width: "450px", height: "250px" },
  },
  {
    src: require("../../assets/puzzle2.webp"),
    title: "Auditing Services",
    text: " ",
    hoverText: "Navigate legal complexities.",
    position: { top: "0px", left: "-220px" },
    size: { width: "300px", height: "300px" },
  },
  {
    src: require("../../assets/puzzle3.webp"),
    title: "Accounting Services",
    text: " ",
    hoverText: "Strategic growth plans.",
    position: { top: "-1px", left: "-405px" },
    size: { width: "450px", height: "245px" },
  },
  {
    src: require("../../assets/puzzle4.webp"),
    title: "IT Solutions",
    text: " ",
    hoverText: "Efficient supply chain.",
    position: { top: "-30px", left: "-535px" },
    size: { width: "270px", height: "300px" },
  },
  {
    src: require("../../assets/puzzle5.webp"),
    title: "Supply Chain",
    text: " .",
    hoverText: "Innovative IT services.",
    position: { top: "-125px", left: "-77px" },
    size: { width: "450px", height: "307px" },
  },
  {
    src: require("../../assets/puzzle6.webp"),
    title: "Business Development",
    text: " ",
    hoverText: "Optimized HR solutions.",
    position: { top: "-105px", left: "-267px" },
    size: { width: "340px", height: "320px" },
  },
  {
    src: require("../../assets/puzzle7.webp"),
    title: "HR Services",
    text: " ",
    hoverText: "Custom web solutions.",
    position: { top: "-140px", left: "-375px" },
    size: { width: "335px", height: "330px" },
  },
  {
    src: require("../../assets/puzzle8.webp"),
    title: "Legal Consultation",
    text: "",
    hoverText: "Effective marketing campaigns.",
    position: { top: "-142px", left: "-593px" },
    size: { width: "330px", height: "330px" },
  },
];

const BusinessSolutions = () => {
  const words = [
    "FINANCE",
    "AUDITING",
    "ACCOUNTING",
    "IT",
    "SUPPLY CHAIN",
    "SALES",
    "HR",
    "LEGAL",
  ];

  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const sections = document.querySelectorAll(".animate-on-scroll");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.forEach((section) => observer.observe(section));
    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return (
    <div className="business-solutions-page">
      <div className="header-background">
        <h1 className="page-title animate-on-scroll">
          We solve your <br />
          <span className="changing-word">{words[currentWordIndex]}</span>{" "}
          Problems
        </h1>

        <div className="reasons-section animate-on-scroll">
          <h2 className="reasons-title">
            REASONS YOU NEED BUSINESS SOLUTION COMPANY FOR
          </h2>

          <div className="reasons-grid">
            {[
              "A Lack Of Understanding Of Business And Customer Insights",
              "Uncertainty About Current Or Future Market",
              "A Misaligned Vision And Strategy",
              "Difficulty Innovating Or Quickly Launching New Capabilities",
              "Poor Strategy Execution And Value Realization",
              "Overall Lack Of Business Agility Across Employees, Process And Technology",
            ].map((reason, index) => (
              <div key={index} className="reason-box">
                <h3>{`0${index + 1}.`}</h3>
                <p>{reason}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="solutions-description animate-on-scroll">
        <p>
          At BinRashid Egypt, we provide comprehensive, 360° business solutions
          across Financial Solutions, Legal Consultation, Business Development &
          Sales, Supply Chain & Logistics, IT Solutions, Human Resources
          Services, Web and Mobile Development, Marketing and Advertising, and
          Public Relations Services, ensuring businesses operate efficiently and
          achieve sustainable growth.
        </p>
      </div>
      <div className="puzzle-section animate-on-scroll">
        <img src={fullpuzzle} alt="Business Solutions Puzzle" className="fullpuzlle" />
      </div>
      {/* <div className="puzzle-section animate-on-scroll">
        <div className="puzzle-grid">
          {puzzleItems.map((item, index) => (
            <div
              key={index}
              className={`puzzle-piece piece-${index}`}
              data-position={index}
              style={{
                transform: `translate(${item.position.left}, ${item.position.top})`,
                width: item.size.width,
                height: item.size.height,
              }}
            >
              <img loading="lazy" src={item.src} alt={`Puzzle ${index + 1}`} />
              <div className="puzzle-content">
                <h3 className="puzzle-title">{item.title}</h3>
                <p className="puzzle-text">{item.text}</p>
                <p className="puzzle-hover-text">{item.hoverText}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default BusinessSolutions;
